import React, { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useCategoriesUIContext } from "../CategoriesUIContext";

const prepareFilter = (queryParams, values) => {
  const { status, searchText } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};
  // Filter by status
  filter.status = status !== "" ? +status : undefined;
 // Filter by all fields
  filter.name = searchText;
  if (searchText) {
    filter.email = searchText;
    filter.id = searchText;
  }
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function CategoriesFilter({ listLoading }) {
  // Categories UI Context
  const categoriesUIContext = useCategoriesUIContext();
  const categoriesUIProps = useMemo(() => {
    return {
      setQueryParams: categoriesUIContext.setQueryParams,
      queryParams: categoriesUIContext.queryParams,
    };
  }, [categoriesUIContext]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(categoriesUIProps.queryParams, values);
    if (!isEqual(newQueryParams, categoriesUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      categoriesUIProps.setQueryParams(newQueryParams);
    }
  };

  if (((window.location.pathname.split("/")[2]) === "approved") || (window.location.pathname.split("/")[2]) === "rejected" || (window.location.pathname.split("/")[2]) === "pending") {
    return (
      <>
        <Formik
          initialValues={{
            approval_status: "",
            searchText: "",
          }}
          onSubmit={(values) => {
            applyFilter(values);
          }}
        >
          {({
            values,
            handleSubmit,
            handleBlur,
            handleChange,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit} className="form form-label-right">
              <div className="form-group row">
                <div className="col-lg-3">
                  <input
                    type="text"
                    className="form-control"
                    name="searchText"
                    placeholder="Search"
                    onBlur={handleBlur}
                    value={values.searchText}
                    onChange={(e) => {
                      setFieldValue("searchText", e.target.value);
                      handleSubmit();
                    }}
                  />
                  <small className="form-text text-muted">
                    <b>Search</b> in all fields
                  </small>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </>
    );
  }
  else {
    return (
      <>
        <Formik
          initialValues={{
            status: "", // values => All=""/Selling=0/Sold=1
            condition: "", // values => All=""/New=0/Used=1
            searchText: "",
          }}
          onSubmit={(values) => {
            applyFilter(values);
          }}
        >
          {({
            values,
            handleSubmit,
            handleBlur,
            handleChange,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit} className="form form-label-right">
              <div className="form-group row">
                <div className="col-lg-2">
                  <select
                    className="form-control"
                    name="status"
                    placeholder="Filter by Status"
                    onChange={(e) => {
                      setFieldValue("status", e.target.value);
                      handleSubmit();
                    }}
                    onBlur={handleBlur}
                    value={values.status}
                  >
                    <option value="-1">All</option>
                    <option value="0">Active</option>
                    <option value="1">Inactive</option>
                  </select>
                  <small className="form-text text-muted">
                    <b>Filter</b> by Status
                  </small>
                </div>
                
                <div className="col-lg-2">
                  <input
                    type="text"
                    className="form-control"
                    name="searchText"
                    placeholder="Search"
                    onBlur={handleBlur}
                    value={values.searchText}
                    onChange={(e) => {
                      setFieldValue("searchText", e.target.value);
                      handleSubmit();
                    }}
                  />
                  <small className="form-text text-muted">
                    <b>Search</b> in all fields
                  </small>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </>
    );
  }
}
